import React from 'react';
import MainSidebar from './MainSidebar';
import { FiBox, FiLayers, FiTool } from 'react-icons/fi';

export default function ProductsSidebar() {
  const menuItems = [
    {
      id: 'products',
      title: 'Products/Services',
      links: [
        { path: '/products/catalog', label: 'List', icon: FiBox }
      ]
    },
    {
      id: 'stock',
      title: 'Stock & Warehouses',
      links: [
        { path: '/products/stock', label: 'List', icon: FiLayers }
      ]
    },
    {
      id: 'mrp',
      title: 'Manufacturing (MRP)',
      links: [
        { path: '/mrp', label: 'Orders List', icon: FiTool }
      ]
    }
  ];
  
  return <MainSidebar moduleName="Products & MRP" menuItems={menuItems} />;
}